<template>
	<footer class="footer">
		<ul class="footer__menu">
		  <li><a class="" v-on:click="showModal" href="#">γενικά για τη χαρακτική</a></li>
		  <li><router-link to="/" active-class="active" exact>εργαστήριο χαρακτικής</router-link></li>
		  <li><router-link to="/xilografia" active-class="active">ξυλογραφία</router-link></li>
		  <li><router-link to="/oxigrafia" active-class="active">οξυγραφία</router-link></li>
		  <li><router-link to="/lithografia" active-class="active">λιθογραφία</router-link></li>
		  <li><router-link to="/gallery" active-class="active">γκαλερί</router-link></li>
		</ul>
	</footer>
</template>

<script>
export default {
  name: 'footer',
  methods: {
    showModal: function (event) {
      event.preventDefault();
      this.$emit('showModal', event)
    }
  }
}
</script>


// WEBPACK FOOTER //
// Footer.vue?46bc6de5